import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';
import OutstandingCard from './outstanding-card.presentation';
import {
  downloadMyPaymentOutstandingAsync,
  setMyPaymentOutstandingSearchText,
  setTappedOutstandingItemNo,
  showErrorSnackbar,
} from '../../redux/action';
import { CART_TAB_CIP, PAYMENT_TYPE_CASH } from '../../constant';
import LocalizedString from '../../localization';
import { isCgsItem, isShowCartTabs, unauthorizedErrorHandler } from '../../helper';

const getFilteredBl = (state, data) => _.values(data)
  .filter((item) => {
    const searchText = state.uiMyPaymentOutstanding.searchBarText.toLowerCase();

    if (item.outstandingType === PAYMENT_TYPE_CASH) {
      return item.proformaNo.toLowerCase().indexOf(searchText) >= 0
        || (item.blNumber && item.blNumber.toLowerCase().indexOf(searchText) >= 0)
        || (item.items && item.items
          .some(innerItem => innerItem.blNumber.toLowerCase().indexOf(searchText) >= 0))
        || (item.service && item.service.toLowerCase().indexOf(searchText) >= 0);
    }
    if (item.invoiceNo) {
      return item.invoiceNo.toLowerCase().indexOf(searchText) >= 0
        || item.blNumber.toLowerCase().indexOf(searchText) >= 0
        || item.service.toLowerCase().indexOf(searchText) >= 0;
    }

    return true;
  });

const getData = (state) => {
  const { currentUser, myOutstandingOrder, uiMyPayment } = state;
  const { selectedInnerTab } = uiMyPayment;

  const hasBothPaymentMethods = isShowCartTabs(currentUser.company);

  if (hasBothPaymentMethods) {
    const initData = Object.values(myOutstandingOrder)
      .map(x => ({
        ...x,
        originalService: x.items
          ? x.items[0].originalService || x.items[0].service
          : x.originalService || x.service,
      }));
    const cipTabData = initData.filter(x => !isCgsItem(x, 'originalService'));
    const cgsTabData = initData.filter(x => isCgsItem(x, 'originalService'));
    const result = selectedInnerTab === CART_TAB_CIP ? cipTabData : cgsTabData;
    return getFilteredBl(state, result);
  }
  return getFilteredBl(state, myOutstandingOrder);
};

const mapStateToProps = state => ({
  downloading: state.uiMyPaymentOutstanding.downloading,
  bl: getData(state),
  searchBarText: state.uiMyPaymentOutstanding.searchBarText,
  selectedItemNo: state.uiMyPaymentOutstanding.tappedItemNo,
  userCompany: state.currentUser.company,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onAppear: async () => {
    try {
      await dispatch(downloadMyPaymentOutstandingAsync());
    } catch (error) {
      dispatch(showErrorSnackbar(LocalizedString.common.alertTitleError, error.message));
      unauthorizedErrorHandler(error, ownProps.history.push);
    }
  },
  onChangeSearchBarText: (text) => {
    dispatch(setMyPaymentOutstandingSearchText(text));
  },
  onMorePressed: (tappedItemNo) => {
    dispatch(setTappedOutstandingItemNo(tappedItemNo));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OutstandingCard));
